"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newsletterSignup = exports.checkoutDeallocate = exports.checkoutCreate = exports.checkoutComplete = exports.checkoutAllocate = void 0;
var checkoutAllocate = {
  projection: "\n    mutation($input: AwyesCheckoutInput!) {\n      checkoutAllocate(input: $input) {\n        sessionId\n        orderId\n        status\n        items {\n          awyesId\n          code\n          price\n        }\n        totalCost\n        offerCode\n      }\n    }\n  ",
  resolverField: 'checkoutAllocate'
};
exports.checkoutAllocate = checkoutAllocate;
var checkoutDeallocate = {
  projection: "\n    mutation($input: AwyesCheckoutInput!) {\n      checkoutDeallocate(input: $input) {\n        sessionId\n        orderId\n        status\n        items {\n          awyesId\n          code\n          price\n        }\n        totalCost\n        offerCode\n      }\n    }\n  ",
  resolverField: 'checkoutDeallocate'
};
exports.checkoutDeallocate = checkoutDeallocate;
var checkoutCreate = {
  projection: "\n    mutation($input: AwyesCheckoutInput!) {\n      checkoutCreate(input: $input) {\n        sessionId\n        orderId\n        status\n        items {\n          awyesId\n          code\n          price\n        }\n        totalCost\n        offerCode\n      }\n    }\n  ",
  resolverField: 'checkoutCreate'
};
exports.checkoutCreate = checkoutCreate;
var checkoutComplete = {
  projection: "\n    mutation($input: AwyesCheckoutCompleteInput!) {\n      checkoutComplete(input: $input) {\n        sessionId\n        orderId\n        status\n        items {\n          awyesId\n          code\n          price\n        }\n        totalCost\n        offerCode\n      }\n    }\n  ",
  resolverField: 'checkoutComplete'
};
exports.checkoutComplete = checkoutComplete;
var newsletterSignup = {
  projection: "\n    mutation($input: AwyesNewsletterInput!) {\n      newsletterSignup(input: $input) {\n        error\n        subscribed\n      }\n    }\n  ",
  resolverField: 'newsletterSignup'
};
exports.newsletterSignup = newsletterSignup;